import { render } from "./StockProductsList.vue?vue&type=template&id=a4bab394"
import script from "./StockProductsList.vue?vue&type=script&lang=js"
export * from "./StockProductsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__